import React from 'react';
import WrapperInputGroup from "./WrapperInputGroup";
import PropTypes from "prop-types";
class Autocomplete extends React.Component {
    constructor(props) {
        super(props);
        props.input.value = props.input.value || "";
    }

    render() {
        return (
            <div className="autocomplete-input-group">
                <input list={this.props.input.listId} onFocus={this.props.onFocus} name={this.props.input.name} id={this.props.input.id} onChange={this.props.onChange}
                       onBlur={this.props.onBlur} disabled={this.props.input.disabled} value={this.props.input.value} required={this.props.input.required}/>
                <datalist id={this.props.input.listId}>
                    { this.props.input.options.map((option) => (
                        <option key={option.key} value={option.value}>{option.text}</option>
                    ))}
                </datalist>
            </div>
        )
    }
}

export const AutocompleteGroup = WrapperInputGroup(Autocomplete);


AutocompleteGroup.propTypes = {
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        name: PropTypes.string.isRequired,
        required: PropTypes.bool.isRequired,
        disabled: PropTypes.bool.isRequired,
        options: PropTypes.arrayOf(PropTypes.object),
        listId: PropTypes.string.isRequired
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/input/base/AutocompleteGroup.js